import CustomButton from '../../../../components/customButton';
import {ICalculateLoanResponse} from '../../../../services/hookService/getCalculateLoan';
import {addCommas} from '../../../../utilities/helper/numberHelper';

interface LoanResultProps {
  data: ICalculateLoanResponse | undefined;
  setView: React.Dispatch<React.SetStateAction<'form' | 'result'>>;
}

const LoanResult = ({data, setView}: LoanResultProps) => {
  if (!data) return null;
  return (
    <div className="flex flex-col flex-1 w-screen gap-2 mt-3 text-gray-700 text-md">
      <div className="grid items-center grid-cols-2 p-6 py-3 border-b border-gray-200 ">
        <span>مبلغ وام درخواستی</span>
        <span className="flex gap-2 pr-4 font-semibold text-right">
          {addCommas(data.amount.toString())}
          <span>تومان</span>
        </span>
      </div>
      <div className="grid items-center grid-cols-2 p-6 py-3 border-b border-gray-200 ">
        <span>زمان بازپرداخت</span>
        <span className="flex gap-1 pr-4 font-semibold text-right">
          {data.total_repayment_time}
          <span>ماهه</span>
        </span>
      </div>

      <div className="grid items-center grid-cols-2 p-6 py-3 border-b border-gray-200 ">
        <span>فاصله میان بازپرداخت اقساط</span>
        <span className="flex gap-1 pr-4 font-semibold text-right">
          {data.repayment_interval}
          <span>ماه</span>
        </span>
      </div>

      <div className="grid items-center grid-cols-2 p-6 py-3 border-b border-gray-200 ">
        <span>نرخ سود وام</span>
        <span className="pr-4 font-semibold text-right">
          {data.loan_rate} درصد
        </span>
      </div>

      <div className="grid items-center grid-cols-2 p-6 py-3 border-b border-gray-200 ">
        <span>مبلغ هر قسط</span>
        <span className="flex gap-2 pr-4 font-semibold text-right">
          {addCommas(data.installment_amount.toString())}
          <span>تومان</span>
        </span>
      </div>

      <div className="grid items-center grid-cols-2 p-6 py-3 border-b border-gray-200 ">
        <span>کل سود وام</span>
        <span className="flex gap-2 pr-4 font-semibold text-right">
          {addCommas(data.total_profit_amount.toString())}
          <span>تومان</span>
        </span>
      </div>

      <div className="grid items-center grid-cols-2 p-6 py-3 border-b border-gray-200 ">
        <span>جمع اصل و سود پرداختی وام</span>
        <span className="flex gap-2 pr-4 font-semibold text-right">
          {addCommas(data.final_loan_amount.toString())}
          <span>تومان</span>
        </span>
      </div>

      <div className="p-6 mt-auto">
        <CustomButton
          title="متوجه شدم"
          onClick={() => setView('form')}
          className="py-3"
        />
      </div>
    </div>
  );
};

export default LoanResult;
